// Utilidades de fecha en hora LOCAL.
// No usar toISOString() para obtener la fecha del día: devuelve la fecha en UTC,
// lo que en Chile (UTC-3/-4) adelanta un día a partir de las 20:00-21:00.

// Date -> "YYYY-MM-DD" en hora local
export const formatearFechaISO = (fecha = new Date()) => {
  const y = fecha.getFullYear();
  const m = String(fecha.getMonth() + 1).padStart(2, '0');
  const d = String(fecha.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// "YYYY-MM-DD" -> Date a medianoche local (new Date('YYYY-MM-DD') la interpreta como UTC)
export const parsearFechaLocal = (fechaStr) => {
  const [y, m, d] = String(fechaStr).split('T')[0].split('-').map(Number);
  return new Date(y, m - 1, d);
};

// Fecha de hoy (local) desplazada en días, en formato "YYYY-MM-DD"
export const fechaHoyMasDias = (dias = 0) => {
  const fecha = new Date();
  fecha.setDate(fecha.getDate() + dias);
  return formatearFechaISO(fecha);
};

// Fecha de hoy (local) desplazada en meses, en formato "YYYY-MM-DD"
export const fechaHoyMasMeses = (meses = 0) => {
  const fecha = new Date();
  fecha.setMonth(fecha.getMonth() + meses);
  return formatearFechaISO(fecha);
};

export const fechaHoy = () => fechaHoyMasDias(0);
